import { Grid } from '@material-ui/core';
import { Button, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { delinquencyService } from '../delinquencyService';

export type PostMortemFormData = {
  comments: string;
};

export type PostMortemFormProps = {
  handleClose: () => void;
  loanId?: string;
  onSave?: (data: PostMortemFormData) => void | Promise<void>;
};

export const PostMortemForm = observer(
  ({ handleClose, loanId, onSave }: PostMortemFormProps) => {
    const [comments, setComments] = useState('');

    const handleSubmit = async () => {
      const data = { comments };
      if (loanId != null) {
        await delinquencyService.saveCustomField(
          loanId,
          'delinquencyComments',
          comments
        );
      }
      if (onSave) {
        await onSave(data);
      }
      handleClose();
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label="Comments"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            fullWidth
            multiline
            minRows={8}
            margin="normal"
            testId="post-mortem-comments"
          />
        </Grid>
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="default"
              testId="post-mortem-cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="primary"
              testId="post-mortem-submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
